
namespace RedBullMOBILE360.SMSCodes {

    @Serenity.Decorators.registerClass()
    export class ServiceSmsDialog extends Serenity.EntityDialog<ServiceSmsRow, any> {
        protected getFormKey() { return ServiceSmsForm.formKey; }
        protected getIdProperty() { return ServiceSmsRow.idProperty; }
        protected getLocalTextPrefix() { return ServiceSmsRow.localTextPrefix; }
        protected getNameProperty() { return ServiceSmsRow.nameProperty; }
        protected getService() { return ServiceSmsService.baseUrl; }
        protected getDeletePermission() { return ServiceSmsRow.deletePermission; }
        protected getInsertPermission() { return ServiceSmsRow.insertPermission; }
        protected getUpdatePermission() { return ServiceSmsRow.updatePermission; }

        protected form = new ServiceSmsForm(this.idPrefix);

    }
}